import type { FunctionComponentWithRef } from "react";
import { graphql, useFragment } from "react-relay";

import { withHighlightedHeadline } from "scmp-app/components/content/content-item-render/highlight/hoc";
import { useContentItemProviders } from "scmp-app/components/content/content-item-render/hooks";
import type { ContentItemRenderVariantProps } from "scmp-app/components/content/content-item-render/types";
import type { plusWebinarWidgetContentItemContent$key } from "scmp-app/queries/__generated__/plusWebinarWidgetContentItemContent.graphql";

import { Container, CoverImage, CoverLink, Headline, HeadlineLink } from "./styles";

export type Props = ContentItemRenderVariantProps & {
  onClick?: () => void;
  reference: plusWebinarWidgetContentItemContent$key;
};

export const Component: FunctionComponentWithRef<Props, HTMLDivElement> = ({
  className,
  onClick,
  ref,
  reference,
}) => {
  const entity = useFragment(
    graphql`
      fragment plusWebinarWidgetContentItemContent on Content {
        __typename
        ...hooksContentItemProvidersContent
          @arguments(withHeadline: true, withCoverImage: true, withCoverImageSize540x360: true)
      }
    `,
    reference,
  );

  const providers = useContentItemProviders(entity);

  return (
    <Container className={className} ref={ref}>
      <CoverImage>
        <CoverLink onClick={onClick}>
          {providers.coverImage({
            responsiveVariants: {
              desktopUp: "size540x360",
              mobileUp: "size540x360",
              tabletUp: "size540x360",
            },
          })}
        </CoverLink>
      </CoverImage>
      <HeadlineLink onClick={onClick}>
        <Headline>
          {providers.headline({
            preferSocialHeadline: true,
            skipHighlight: true,
          })}
        </Headline>
      </HeadlineLink>
    </Container>
  );
};

Component.displayName = "ContentItemPlusWebinarWidget";
export const ContentItemPlusWebinarWidget = withHighlightedHeadline(Component);
